import { render, staticRenderFns } from "./StockWizard.vue?vue&type=template&id=3121947e"
import script from "./StockWizard.vue?vue&type=script&lang=js"
export * from "./StockWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports